<!-- Inner Banner Start-->
<section class="inner-hero-banner">
  <div class="inner-hero-text">
    <h1 i18n>About Us</h1>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#" i18n>Home</a></li>
        <li class="breadcrumb-item active" aria-current="page" i18n>
          About Us
        </li>
      </ol>
    </nav>
  </div>
</section>
<!-- Inner Banner End -->

<!-- Line Animations Effect-->
<!-- <div class="lines">
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
          </div>
           -->
<!-- Start About Content Area -->
<section class="section about-content-area">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-md-6 col-sm-12">
        <div
          class="image-container mt-0 wow fadeInUp"
          data-wow-delay="0.2s"
          data-wow-duration="1s"
        >
          <div class="video-wrapper">
            <a
              class="popup-youtube"
              data-toggle="modal"
              data-target="#videomodal"
              href="javascript:void(0)"
            >
              <img
                src="assets/images/video-frame-thumbnail.png"
                class="img-fluid"
                alt=""
              />
              <span class="video-play-button">
                <span></span>
              </span>
            </a>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12">
        <div
          class="about-text-block wow fadeInUp"
          data-wow-delay="0.4s"
          data-wow-duration="1s"
        >
          <div class="about-content">
            <h4 i18n>
              What We Do
            </h4>
            <div class="text" i18n>
              Lineup Orchestration solution <br />1. See your lineup, live, with
              real time data and analytics <br />2. Distribute your customers,
              easy to implement and on demand notifications <br />3. Increase
              Accessibility, build customer loyalty
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="row align-items-center">
      <div class="col-md-6 col-sm-12 order-md-2">
        <div
          class="about-image-block wow fadeInUp"
          data-wow-delay="0.4s"
          data-wow-duration="1s"
        >
          <img src="assets/images/aboutus/team.jpg" class="img-fluid" alt="" />
        </div>
      </div>
      <div class="col-md-6 col-sm-12 order-md-1">
        <div
          class="about-text-block wow fadeInUp"
          data-wow-delay="0.2s"
          data-wow-duration="1s"
        >
          <div class="about-content">
            <h4 i18n>
              Founded in 2020
            </h4>
            <div class="text" i18n>
              We decided to join our forces during the COVID-19 aid to ensure a
              return to work that respects individual integrity in a context of
              physical distancing, how can technology contribute to the
              establishment of good health and safety practices in places like
              factories, universities, restaurants, shopping centres, public
              transportation and concert halls.
              <br />
              <br /><strong
                >Alexandre Ratthé, Brian McWilliams, Mariya Zinchenko</strong
              >
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div
      class="modal fade"
      id="videomodal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="videomodal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content transparent-modal">
          <div class="modal-body p-0">
            <button
              type="button"
              class="close modal-close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/ElMBXyhXAAY"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End About Content Area -->
<!-- Start About Countdown Area-->
<!--
    <section class="parallax parallax-box section">
        <div id="counter">
            <div class="container">
                <div class="row">
                    <div class="col-md-3 col-6">
                        <div class="counter-box text-center">
                            <div class="counter-ico"><i class="mdi mdi-rocket"></i></div>
                            <h3 id="number1" class="number counter-value" data-count="0">0</h3>
                            <span></span>
                            <p i18n>Projects done</p>
                        </div>
                    </div>
                    <div class="col-md-3 col-6">
                        <div class="counter-box text-center">
                            <div class="counter-ico"><i class="mdi mdi-account-group"></i></div>
                            <h3 id="number2" class="number counter-value" data-count="0">0</h3>
                            <span></span>
                            <p i18n>Happy clients</p>
                        </div>
                    </div>
                    <div class="col-md-3 col-6">
                        <div class="counter-box text-center">
                            <div class="counter-ico"><i class="mdi mdi-coffee"></i></div>
                            <h3 id="number3" class="number counter-value" data-count="0">0</h3>
                            <span></span>
                            <p i18n>Cups of coffee</p>
                        </div>
                    </div>
                    <div class="col-md-3 col-6">
                        <div class="counter-box text-center">
                            <div class="counter-ico"><i class="mdi mdi-trophy"></i></div>
                            <h3 id="number4" class="number counter-value" data-count="0">0</h3>
                            <span></span>
                            <p i18n>Awards</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
-->
<!-- End About Countdown Area-->
<!-- Start About Team Area-->

<section class="banner_wrapper">
  <div class="about-content">
    <!--
            <div class="title-block mx-auto">
                <div class="section_title mb-4 text-center">
                    <h2><span i18n>The Best Team</span></h2>
                    <span class="scroll-title" data-enllax-ratio="2.5" data-enllax-type="foreground" data-enllax-direction="horizontal" style="transform: translateX(80px);" i18n>The Best Team</span>
                    <p class="section_subtitle mx-auto" i18n>We are always pushing our bondaries further up the line.</p>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-sm-6">
                    <div class="single-team wow fadeInUp" data-wow-duration="1s">
                        <div class="team-photo">
                            <br/><img src="assets/images/aboutus/team/brian1.jpg" class="img-fluid" alt="">
                            <div class="team-content">
                                <div class="team-social">
                                    <ul>
                                        <li><a href="#"><i class="mdi mdi-facebook-box"></i></a></li>
                                        <li><a href="#"><i class="mdi mdi-instagram"></i></a></li>
                                        <li><a href="#"><i class="mdi mdi-twitter"></i></a></li>
                                        <li><a href="#"><i class="mdi mdi-youtube"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="person-name">
                            <h4>Brian McWilliams</h4>
                            <p i18n>Lead Developer</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-sm-6">
                    <div class="single-team wow fadeInUp" data-wow-duration="1s">
                        <div class="team-photo">
                            <img src="assets/images/aboutus/team/mariya2.jpg" class="img-fluid" alt="">
                            <div class="team-content">
                                <div class="team-social">
                                    <ul>
                                        <li><a href="#"><i class="mdi mdi-facebook-box"></i></a></li>
                                        <li><a href="#"><i class="mdi mdi-instagram"></i></a></li>
                                        <li><a href="#"><i class="mdi mdi-twitter"></i></a></li>
                                        <li><a href="#"><i class="mdi mdi-youtube"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="person-name">
                            <h4>Mariya Zinchenko</h4>
                            <p i18n>Developer & Designer</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-sm-6">
                    <div class="single-team wow fadeInUp" data-wow-duration="1s">
                        <div class="team-photo">
                            <img src="assets/images/aboutus/team/alexandre3.jpg" class="img-fluid" alt="">
                            <div class="team-content">
                                <div class="team-social">
                                    <ul>
                                        <li><a href="#"><i class="mdi mdi-facebook-box"></i></a></li>
                                        <li><a href="#"><i class="mdi mdi-instagram"></i></a></li>
                                        <li><a href="#"><i class="mdi mdi-twitter"></i></a></li>
                                        <li><a href="#"><i class="mdi mdi-youtube"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="person-name">
                            <h4>Alexandre Ratthé</h4>
                            <p i18n>Sales & Marketing</p>
                        </div>
                    </div>
              </div>
-->
    <!--  
                <div class="col-lg-4 col-sm-6">
                    <div class="single-team wow fadeInUp" data-wow-duration="1.5s">
                        <div class="team-photo">
                            <img src="assets/images/aboutus/team/4.jpg" class="img-fluid" alt="">
                            <div class="team-content">
                                <div class="team-social">
                                    <ul>
                                        <li><a href="#"><i class="mdi mdi-facebook-box"></i></a></li>
                                        <li><a href="#"><i class="mdi mdi-instagram"></i></a></li>
                                        <li><a href="#"><i class="mdi mdi-twitter"></i></a></li>
                                        <li><a href="#"><i class="mdi mdi-youtube"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="person-name">
                            <h4>Daniel Smith</h4>
                            <p>SEO Expert</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-sm-6">
                    <div class="single-team wow fadeInUp" data-wow-duration="1.5s">
                        <div class="team-photo">
                            <img src="assets/images/aboutus/team/5.jpg" class="img-fluid" alt="">
                            <div class="team-content">
                                <div class="team-social">
                                    <ul>
                                        <li><a href="#"><i class="mdi mdi-facebook-box"></i></a></li>
                                        <li><a href="#"><i class="mdi mdi-instagram"></i></a></li>
                                        <li><a href="#"><i class="mdi mdi-twitter"></i></a></li>
                                        <li><a href="#"><i class="mdi mdi-youtube"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="person-name">
                            <h4>Adam John</h4>
                            <p>Web Developer</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-sm-6">
                    <div class="single-team wow fadeInUp" data-wow-duration="1.5s">
                        <div class="team-photo">
                            <img src="assets/images/aboutus/team/6.jpg" class="img-fluid" alt="">
                            <div class="team-content">
                                <div class="team-social">
                                    <ul>
                                        <li><a href="#"><i class="mdi mdi-facebook-box"></i></a></li>
                                        <li><a href="#"><i class="mdi mdi-instagram"></i></a></li>
                                        <li><a href="#"><i class="mdi mdi-twitter"></i></a></li>
                                        <li><a href="#"><i class="mdi mdi-youtube"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="person-name">
                            <h4>kathy Snow</h4>
                            <p>BDE Expert</p>
                        </div>
                    </div>
                </div>

            </div>
-->

    <!-- <div class="title-block mx-auto">
      <div class="section_title mb-4 text-center">
        <div
          class="image-container wow fadeInLeft"
          data-wow-delay="0.2s"
          data-wow-duration="1s"
        >
          <h2><span i18n>We Engineer for accessibility</span></h2>
          <div class="text" i18n>
            We are building the fast line without excluding slower customers.
            <br />
            We remove barriers, for people who can't physically stand in line,
            or don't have the time to. <br />
            More importantly, we believe that we reach these goals without
            sacrificing efficiency.
          </div>
        </div>
      </div>
    </div> -->
    <br />
    <br />
    <!-- <div class="title-block mx-auto">
            <div class="section_title mb-4 text-center">
                <div class="image-container wow fadeInRight" data-wow-delay="0.2s" data-wow-duration="1s">
                    <h2><span i18n>We believe in a world without friction</span></h2>
                    <div class="text" i18n>At EnLiiigne, we believe that shopping in store can be just as convenient as shopping online, even with social distancing
                    </div>
                </div>
            </div>
        </div> -->
  </div>
  <br />
  <br />
</section>
<!-- End About Team Area-->
